// Generated by ReScript, PLEASE EDIT WITH CARE


var $$default = "Default";

var partners = "Partners";

var services_pillar = "Service Page";

var services_keyword = "Service Page - ";

var services_trucks_keyword = "Trucks Keyword - ";

var services_2w_keyword = "2W Keyword - ";

var services_courier_keyword = "Courier Keyword - ";

var pnm_pillar = "Pnm Home";

var pnm_city = "Pnm City - ";

var pnm_hyperlocal = "Pnm Hyperlocal - ";

var v1_2w_city = "Two Wheelers Page - ";

var v2_2w_city = "Two Wheelers Page - ";

var trucks_city = "City ";

var trucks_inventory = "City Inventory - ";

var fare_estimate_mob = "Fare Estimate Result";

var enterprise = "Enterprise";

var city = "City ";

var enterprise_lead_page = "Enterprise-lead-page";

var support = "Support";

var privacy_policy = "Privacy Policy";

var privacy_policy_v1 = "Privacy Policy V1";

var privacy_policy_v2 = "Privacy Policy V2";

var enterprise_faq = "Enterprise Faq";

var spot_faq = "Spot Faq";

var porter_wallet_faq = "Porter Wallet Faq";

var insurance_faq = "Insurance Faq";

var terms_of_service_partners = "ToS Partners";

var referral_tnc = "Refferal TnC";

var courier_tnc = "Courier TnC";

var cookie_policy = "Cookie Policy";

var terms_of_service = "Terms of Service";

var about_us = "About Us";

var careers = "Careers";

var offers = "Offers";

var offers_cashback = "Cashback";

var offers_discount = "Discount";

var courier = "Courier";

var courier_city = "Courier Page - ";

var governance = "Governance";

var home = "Home";

var trucks_pillar = "Trucks Main";

var bikes_pillar = "Bikes Main";

export {
  $$default ,
  $$default as default,
  partners ,
  services_pillar ,
  services_keyword ,
  services_trucks_keyword ,
  services_2w_keyword ,
  services_courier_keyword ,
  pnm_pillar ,
  pnm_city ,
  pnm_hyperlocal ,
  v1_2w_city ,
  v2_2w_city ,
  trucks_city ,
  trucks_inventory ,
  fare_estimate_mob ,
  enterprise ,
  city ,
  enterprise_lead_page ,
  support ,
  privacy_policy ,
  privacy_policy_v1 ,
  privacy_policy_v2 ,
  enterprise_faq ,
  spot_faq ,
  porter_wallet_faq ,
  insurance_faq ,
  terms_of_service_partners ,
  referral_tnc ,
  courier_tnc ,
  cookie_policy ,
  terms_of_service ,
  about_us ,
  careers ,
  offers ,
  offers_cashback ,
  offers_discount ,
  courier ,
  courier_city ,
  governance ,
  home ,
  trucks_pillar ,
  bikes_pillar ,
}
/* No side effect */
